import { castArray, map } from 'lodash-es';

import { services } from 'services/base';
import { RegisterSidebarItemService, UpdateSidebarService } from 'types';
import { isAppModule, isSidebarNavigationModule } from 'utils';

/**
 * When a sidebar item is registered setting the order prop to lower or higher
 * can be used to change the position (display order) of sidebar items.
 */
const DEFAULT_SIDEBAR_ITEM_ORDER = 1000;

const SERVICE_PREFIX = 'appFrame.sidebar';

const getSidebarDefaultItems = () => {
  const modules = services.appFrame.config.getModulesConfig() || [];
  return modules.filter(isAppModule).filter(isSidebarNavigationModule);
};

const initSidebarServices = () => {
  const { registerCollection, registerService } = services;

  // TODO: please take care when `appFrame.config.setModulesConfig(...) default items need to be re-calculated!
  registerCollection(SERVICE_PREFIX, getSidebarDefaultItems(), DEFAULT_SIDEBAR_ITEM_ORDER);

  registerService<RegisterSidebarItemService>(`${SERVICE_PREFIX}.registerItem`, (items) => {
    const result = map(castArray(items), (item) => services.appFrame.sidebar.addItem(item));
    return result;
  });

  registerService<UpdateSidebarService>(`${SERVICE_PREFIX}.update`, () => {
    services.appFrame.sidebar.updateItem([]);
  });

  services.appFrame.config.onModulesConfigChange(() => {
    services.appFrame.sidebar.setDefaultItems(getSidebarDefaultItems());
  });

  services.appFrame.config.onFeaturesChange(() => {
    services.appFrame.sidebar.setDefaultItems(getSidebarDefaultItems());
  });
};

export default initSidebarServices;
